/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/case.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Accepts pairs of conditions and values. The function returns the value that\nbelongs to the first condition that evaluates to `true`. Both the conditions\nand the returned values can be any expression, including column references.\n\nIf the number of arguments is odd, the last argument is the default value which\nis returned when no condition matches. If the number of arguments is even, and\nno condition matches, the function returns `null`.',
  examples: [
    'FROM employees\n| EVAL type = CASE(\n    languages <= 1, "monolingual",\n    languages <= 2, "bilingual",\n     "polyglot")\n| KEEP emp_no, languages, type',
    'FROM sample_data\n| EVAL successful = CASE(\n    STARTS_WITH(message, "Connected to"), 1,\n    message == "Connection error", 0\n  )\n| STATS success_rate = AVG(successful)',
    'FROM sample_data\n| EVAL error = CASE(message LIKE "*error*", 1, 0)\n| EVAL hour = DATE_TRUNC(1 hour, @timestamp)\n| STATS error_rate = AVG(error) by hour\n| SORT hour',
    'FROM sample_data\n| EVAL error_message = CASE(message LIKE "*error*", message, null)\n| STATS distinct_error_messages = COUNT_DISTINCT(error_message)',
  ],
  params: {
    condition: 'A condition.',
    trueValue: 'The expression or value that’s returned when the corresponding condition is the first to evaluate to `true`. Can be a column reference or any other expression. The default value is returned when no condition matches.',
    elseValue: 'The value that’s returned when no condition evaluates to `true`.',
  },
};

export default docs;
